module.exports = __webpack_public_path__ + "img/logo-brasilcard.541a1ef7.svg";